import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  invalidState: {
    id: 'studio.RPmD9J',
    defaultMessage: 'The state parameter is invalid. Please try again.',
  },
  registrationConflict: {
    id: 'studio.jiN18R',
    defaultMessage:
      'The linked email address is already assigned to an existing Appsemble account. Please login and try again.',
  },
  loginError: {
    id: 'studio.cODiHI',
    defaultMessage: 'There was a problem logging in. Please try again.',
  },
  confirmCreateText: {
    id: 'studio.g807h/',
    defaultMessage: 'Would you like to create an account using this {provider} account?',
  },
  confirmCreate: {
    id: 'studio.phTfBA',
    defaultMessage: 'Create new account',
  },
  confirmLinkText: {
    id: 'studio.Qkauj5',
    defaultMessage: 'Would you like to link this {provider} account to your Appsemble account?',
  },
  confirmLink: {
    id: 'studio.l3RRaO',
    defaultMessage: 'Link account',
  },
  loginInstead: {
    id: 'studio.jI+73R',
    defaultMessage:
      'Already have an account? <link>Login</link> and link to an existing account instead.',
  },
});
